import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Link16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.4947 6.89431L12.1412 7.24787L13.2018 8.30853L13.5554 7.95497C15.2151 6.29524 15.2151 3.60429 13.5554 1.94456C11.8956 0.284836 9.20469 0.284836 7.54497 1.94456L6.13075 3.35878C4.47102 5.01851 4.47102 7.70946 6.13075 9.36919L7.19141 8.30853C6.11747 7.23458 6.11747 5.49338 7.19141 4.41944L8.60563 3.00522C9.67957 1.93128 11.4208 1.93128 12.4947 3.00522C13.5687 4.07917 13.5687 5.82037 12.4947 6.89431Z'
      fill='currentColor'
    />
    <path
      d='M3.00535 12.5511C1.9314 11.4771 1.9314 9.73591 3.00535 8.66196L3.3589 8.30841L2.29824 7.24775L1.94469 7.6013C0.284958 9.26103 0.284958 11.952 1.94469 13.6117C3.60441 15.2714 6.29537 15.2714 7.95509 13.6117L9.36931 12.1975C11.029 10.5378 11.029 7.84682 9.36931 6.18709L8.30865 7.24775C9.38259 8.32169 9.38259 10.0629 8.30865 11.1368L6.89443 12.5511C5.82049 13.625 4.07929 13.625 3.00535 12.5511Z'
      fill='currentColor'
    />
  </Svg>
);

Link16.displayName = 'Link16';
export default Link16;
